import { gql } from "@apollo/client";

export const GET_ALL_TIPO_SERVICIO = gql`
query GetAllTipoServicio {
    allTipoServicio{
            idTipoServicio,
            descripcion
      }
}`;